const VUE_APP_TENANT_CODE = process.env.VUE_APP_TENANT_CODE
const VUE_APP_ENCRYPTION_KEY = process.env.VUE_APP_ENCRYPTION_KEY
const VUE_APP_I18N_LOCAL = process.env.VUE_APP_I18N_LOCAL
const VUE_APP_API_CONTEXT_PATH = process.env.VUE_APP_API_CONTEXT_PATH

export {
  VUE_APP_TENANT_CODE,
  VUE_APP_ENCRYPTION_KEY,
  VUE_APP_I18N_LOCAL,
  VUE_APP_API_CONTEXT_PATH
}



// WEBPACK FOOTER //
// ./src/utils/env.js